import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M4 11a7 7 0 0 0 7-7h2a7 7 0 0 0 7 7v2a7 7 0 0 0-7 7h-2a7 7 0 0 0-7-7v-2Zm4.127 1A9.04 9.04 0 0 1 12 15.873 9.04 9.04 0 0 1 15.873 12 9.04 9.04 0 0 1 12 8.127 9.04 9.04 0 0 1 8.127 12Z", clipRule: "evenodd" }));
export {
  a as ReactComponent
};
